import { useMutation } from '@tanstack/react-query';
import * as clinicsApi from '../../../../apis/clinics/requests';

const useDeleteClinic = () => {
  const mutation = useMutation({
    mutationFn: (clinicId: string) => {
      return clinicsApi.deleteClinic(clinicId);
    }
  });

  const { mutateAsync: deleteClinic, isLoading } = mutation;

  return { deleteClinic, isLoading };
};



export default useDeleteClinic;
